<template>
    <div class="bg-color">
        <vs-row>
            <vs-col vs-lg="2" class="mt-5 pt-5">
                <img src="@/assets/images/logo/logo.png" width="100%" class="logoStyle"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center">
            <div class="heading my-6">Create an Account</div>
        </vs-row>
        <vs-row vs-justify="center">
                <div class="uploadProfile my-6" @click="$refs.uploadProfilePic.click()">
                    <div class="font-semibold">Upload Picture</div>
                    <input type="file" class="hidden" ref="uploadProfilePic" @change="showProfileImg">
                </div>
        </vs-row>
        <vs-row vs-justify="center">
            <vs-col vs-lg="3" class="inputStyle mx-6">
                <vs-input placeholder="Email" class="w-full"/>
            </vs-col>
            <vs-col vs-lg="3" class="inputStyle mx-6">
                <vs-input placeholder="Password" class="w-full"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center">
            <vs-col vs-lg="3" class="inputStyle mx-6">
                <vs-input placeholder="Initials (DMG)" class="w-full"/>
            </vs-col>
            <vs-col vs-lg="3" class="inputStyle mx-6">
                <vs-input placeholder="Email Address" class="w-full"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center">
            <vs-col vs-lg="3" class="inputStyle mx-6">
                <vs-input placeholder="Password" class="w-full"/>
            </vs-col>
            <vs-col vs-lg="3" class="inputStyle mx-6">
                <vs-input placeholder="Re-Enter Password" class="w-full"/>
            </vs-col>
        </vs-row>
        <vs-row vs-justify="center">
            <vs-col vs-lg="2" vs-type="flex" vs-justify="center" class="my-5">
                <vs-button class="w-full my-6">Create Account</vs-button>
            </vs-col>
        </vs-row>
         <vs-row vs-justify="center">
            <vs-col vs-lg="3" class="inputStyle my-4" vs-type="flex" vs-justify="center">
                Have an account? <div class="signUpLink font-semibold ml-2">Sign in!</div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    data(){
        return {
            showImg: false
        }
    },
    methods: {
        showProfileImg(){
            this.showImg = this.$refs.uploadProfilePic.files[0];
        }
    }
}

</script>

<style>
    .logoStyle {
        padding: 15%;
        padding-top: 4% !important;
    }
    .heading {
        font-size: 18px;
        color: white;
    }
    .bg-color {
        background-color: #121212;
        height: 100vh;
    }
    .inputStyle .vs-input--input{
        padding: 3% !important;
        margin: 3% 0 !important;
        background-color: #333333;
    }
     .inputStyle .vs-input--placeholder {
            font-size: 100%;
            margin-top: 4% !important;
            margin-left: 1%
     } 
     .signUpLink {
        color:#4B4BF9;
    }
    .uploadProfile {
        background-color: #333333;
        width: 175px;
        height: 175px;
        border-radius: 50%;
    }
    .uploadProfile div {
        margin-left: 50px;
        margin-top: 60px;
        font-size: 20px;
        color: #6E767D;
    }
</style>